import { useState, useCallback } from 'react';
import './PillChoice.css';

export type PillMode = 'red' | 'blue';

interface PillChoiceProps {
  onChoice: (pill: PillMode) => void;
}

export function PillChoice({ onChoice }: PillChoiceProps) {
  const [hoveredPill, setHoveredPill] = useState<PillMode | null>(null);
  const [choosing, setChoosing] = useState(false);

  const handleChoice = useCallback((pill: PillMode) => {
    if (choosing) return; // Prevent double-tap
    console.log(`[PillChoice] Selected: ${pill}`);
    setChoosing(true);
    // Call async but don't await - let it complete in background
    Promise.resolve(onChoice(pill)).catch(err => {
      console.error('[PillChoice] Error:', err);
    });
  }, [onChoice, choosing]);

  return (
    <div className="pill-choice-container">
      <div className="pill-choice-content">
        <h1 className="title">AMORPHOUS</h1>
        <p className="tagline">What you see depends on how you look</p>

        <div className="pills">
          <button
            className={`pill red-pill ${hoveredPill === 'red' ? 'hovered' : ''} ${choosing ? 'disabled' : ''}`}
            onClick={() => handleChoice('red')}
            onTouchEnd={(e) => { e.preventDefault(); handleChoice('red'); }}
            onMouseEnter={() => setHoveredPill('red')}
            onMouseLeave={() => setHoveredPill(null)}
          >
            <span className="pill-icon">O</span>
            <span className="pill-name">RED PILL</span>
            <span className="pill-desc">Raw truth, unfiltered</span>
            <ul className="pill-features">
              <li>Chronological feeds</li>
              <li>Peer reputation visible</li>
              <li>See content hashes</li>
              <li>Developer mode</li>
            </ul>
          </button>

          <div className="pill-divider">
            <span>OR</span>
          </div>

          <button
            className={`pill blue-pill ${hoveredPill === 'blue' ? 'hovered' : ''} ${choosing ? 'disabled' : ''}`}
            onClick={() => handleChoice('blue')}
            onTouchEnd={(e) => { e.preventDefault(); handleChoice('blue'); }}
            onMouseEnter={() => setHoveredPill('blue')}
            onMouseLeave={() => setHoveredPill(null)}
          >
            <span className="pill-icon">O</span>
            <span className="pill-name">BLUE PILL</span>
            <span className="pill-desc">Curated harmony</span>
            <ul className="pill-features">
              <li>Algorithmic sorting</li>
              <li>Clean interface</li>
              <li>Smooth experience</li>
              <li>Consumer mode</li>
            </ul>
          </button>
        </div>

        <p className="switch-note">You can switch modes anytime</p>
      </div>
    </div>
  );
}
